import React from 'react';
import copyrightNoticeYearRange from '../../utils/copyrightNoticeYearRange';
import CTDLogo from '../../../../assets/images/CTD-horizontaldark.png';

const PageFooter = () => {
  return (
    <div className="bg-black w-full">
      <div className="footer-copyright text-center text-white py-3">
        &copy; {copyrightNoticeYearRange(2019)} Vamos Outreach. All rights reserved.
        <br />
        <a href="/privacy_policy" className="underline">
          Privacy Policy
        </a>
        <span> | </span>
        <a href="/terms_and_conditions" className="underline">
          Terms & Conditions
        </a>
        <br />
        Built By <img src={CTDLogo} alt="CTD horizontal logo" className="inline-block align-middle w-46.25 h-5" />
      </div>
    </div>
  );
};
export default PageFooter;
